import React, { useState } from "react";
import Modal from "../utils/Modal";
import ConvertKitForm from 'convertkit-react'

const MY_FORM_ID = 3240397

const config = {
  formId: MY_FORM_ID,
  className: "ck-fm",
  format: 'inline',
  template: 'mills',
  emailPlaceholder: 'Enter an email address',
  submitText: 'Join us',
  headingText: 'We\'ll occasionally send you emails on what we are learning, experiments we are running in building a business, interviews with people and things that interest us in the tech world. You get the idea.',
  buttonBackground :'#005a98',
  backgroundOpacity: 0
}

function HeroHome() {
  const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <section className="relative">
      {/* Illustration behind hero content */}
      <div
        className="absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none"
        aria-hidden="true"
      ></div>
      <svg
        className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
        width={404}
        height={784}
        fill="none"
        viewBox="0 0 404 784"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
            x={0}
            y={0}
            width={20}
            height={20}
            patternUnits="userSpaceOnUse"
          >
            <rect
              x={0}
              y={0}
              width={4}
              height={4}
              className="text-gray-200"
              fill="currentColor"
            />
          </pattern>
        </defs>
        <rect
          width={404}
          height={784}
          fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
        />
      </svg>

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Hero content */}
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          {/* Section header */}
          <div className="text-center pb-12 md:pb-16">
            <div className="space-y-16">
              <h1 className="text-6xl md:text-6xl mb-4" >
                <span className="font-bold leading-relaxed bg-clip-text text-transparent bg-[#005A98]">
                  Building products in public with{" "}
                  <a
                    href="https://serverless-stack.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline decoration-[#ABDDFF]"
                    aria-label="Cruip"
                  >
                    Serverless Stack
                  </a>
                </span>
              </h1>
            </div>
            <div className="max-w-3xl mx-auto space-y-16">
              <div
                className="max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center"
              >
                <div className="space-y-16">
                <ConvertKitForm {...config} />
                </div>
                <div></div>
              </div>
            </div>
          </div>

          {/* Hero image */}
          <div>
            <div
              className="relative flex justify-center mb-8"
              data-aos="zoom-y-out"
              data-aos-delay="450"
            ></div>

            {/* Modal */}
            <Modal
              id="modal"
              ariaLabel="modal-headline"
              show={videoModalOpen}
              handleClose={() => setVideoModalOpen(false)}
            >
              <div className="relative pb-9/16"></div>
            </Modal>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroHome;
